import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65d0a9e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "finish-container" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "second" }
const _hoisted_4 = { class: "tips" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 关闭弹窗后可在 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 查看。 ")

import { onMounted, onUnmounted, ref } from "vue";
import uploadSuccess from "@/assets/images/icon-upload-success.png"
import uploadSuccessGreen from "@/assets/images/icon-upload-success-green.png"
import { IsZhiHuiXingHe } from "@/core/hooks/SetTheme";

import { defineComponent } from "vue";
const __default__ = defineComponent({
  name: "FinishImport",
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  backPage: {
    type: String,
  },
},
  emits: ["handleClose"],
  setup(__props, { emit }) {

const props = __props


const isZHXH=IsZhiHuiXingHe()


const second = ref(3);
let timer;
onMounted(() => {
  timer = setInterval(() => {
    second.value--;
    if (second.value <= 0) {
      clearInterval(timer);
      emit("handleClose");
    }
  }, 1000);
});

onUnmounted(() => {
  timer && clearInterval(timer);
});

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("img", {
          class: "success-icon",
          src: _unref(isZHXH)?_unref(uploadSuccessGreen):_unref(uploadSuccess),
          alt: ""
        }, null, 8, _hoisted_2),
        _createElementVNode("p", _hoisted_3, _toDisplayString(`${second.value}秒后自动关闭`), 1)
      ])
    ]),
    _createElementVNode("p", _hoisted_4, [
      _hoisted_5,
      _createVNode(_component_a_button, {
        type: "link",
        class: "theme-color",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('handleClose')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(__props.backPage), 1)
        ]),
        _: 1
      }),
      _hoisted_6
    ])
  ], 64))
}
}

})